// extracted by mini-css-extract-plugin
export var container = "_ap-0";
export var containerTopRight = "_ap-1";